import axiosInstance from "../../axiosInstance";
import URL from "../../urls";
import {
  GLOBAL_TIME_FILTER,
  CLIENT_SESSIONS,
  CLIENT_SESSIONS_LOADING,
  CLIENT_SESSIONS_ERROR,
  CLIENT_FOLLOWUP_LOADING,
  CLIENT_FOLLOWUP,
  CLIENT_FOLLOWUP_ERROR,
  AVERAGE_SESSIONS_LOADING,
  AVERAGE_SESSIONS,
  AVERAGE_SESSIONS_ERROR,
  SESSION_SUMMARY_LOADING,
  SESSION_SUMMARY,
  SESSION_SUMMARY_ERROR,
  OTHER_INFORMATION_LOADING,
  OTHER_INFORMATION,
  OTHER_INFORMATION_ERROR,
  UPDATE_BATCH_ACTION_STATUS,
  RESET_BATCH_ACTION_STATUS,
  TIME_UTILISATION_LOADING,
  TIME_UTILISATION,
  TIME_UTILISATION_ERROR,
  // DIAGNOSIS_LOADING,
  // DIAGNOSIS_ERROR,
  // DIAGNOSIS,
} from "./types";

export const setGlobalTimeFilter = payload => {
  //const payload = "last_30_days" || "last_90_days" || "last_6_months" || "last_year" || "all_time";
  return dispatch => {
    dispatch({
      type: GLOBAL_TIME_FILTER,
      payload: payload,
    });
  };
};

export const getClientSessions = payload => {
  // const { client_type, time_filter } = payload;
  // "client_type" : "all" || "b2b" || "b2c" || "in-person" || "virtual",
  // "time_filter" : "last_30_days" || "last_90_days" || "last_6_months" || "last_year" || "all_time",

  return async dispatch => {
    try {
      dispatch({ type: CLIENT_SESSIONS_LOADING, payload: true });
      const clientSessionsUrl = URL.clientSessions;
      const response = await axiosInstance.post(clientSessionsUrl, payload);
      dispatch({ type: CLIENT_SESSIONS_ERROR, payload: null });
      dispatch({ type: CLIENT_SESSIONS, payload: response?.data?.data });
    } catch (error) {
      dispatch({ type: CLIENT_SESSIONS_ERROR, payload: error?.message });
    } finally {
      dispatch({ type: CLIENT_SESSIONS_LOADING, payload: false });
    }
  };
};

export const getClientFollowUpData = payload => {
  // const { new_users, client_type, time_filter } = payload;
  // "new_users": true || false,
  // "client_type":"all" || "b2b" || "b2c" || "in-person" || "virtual",
  // "time_filter":"last_30_days" || "last_90_days" || "last_6_months" || "last_year" ||   "all_time",

  return async dispatch => {
    try {
      dispatch({ type: CLIENT_FOLLOWUP_LOADING, payload: true });
      const clientFollowUpUrl = URL.clientFollowup;
      const response = await axiosInstance.post(clientFollowUpUrl, payload);
      dispatch({ type: CLIENT_FOLLOWUP_ERROR, payload: null });
      dispatch({ type: CLIENT_FOLLOWUP, payload: response?.data?.data });
    } catch (error) {
      dispatch({ type: CLIENT_FOLLOWUP_ERROR, payload: error?.message });
    } finally {
      dispatch({ type: CLIENT_FOLLOWUP_LOADING, payload: false });
    }
  };
};

export const getAverageSessionData = payload => {
  // const { new_users, client_type, time_filter } = payload;
  // "new_users": true || false,
  // "client_type":"all" || "b2b" || "b2c" || "in-person" || "virtual",
  // "time_filter":"last_30_days" || "last_90_days" || "last_6_months" || "last_year" ||   "all_time",

  return async dispatch => {
    try {
      dispatch({ type: AVERAGE_SESSIONS_LOADING, payload: true });
      const averageSessionUrl = URL.averageSessions;
      const response = await axiosInstance.post(averageSessionUrl, payload);
      dispatch({ type: AVERAGE_SESSIONS_ERROR, payload: null });
      dispatch({ type: AVERAGE_SESSIONS, payload: response?.data?.data });
    } catch (error) {
      dispatch({ type: AVERAGE_SESSIONS_ERROR, payload: error?.message });
    } finally {
      dispatch({ type: AVERAGE_SESSIONS_LOADING, payload: false });
    }
  };
};

export const getSessionSummary = (payload, signal) => {
  // const {split_by, time_filter}=payload;
  // split_by:"session_mode" || "client_type" || "duration" || "none",
  // time_filter:"last_30_days" || "last_90_days" || "last_6_months" || "last_year" || "all_time",

  return async dispatch => {
    try {
      dispatch({ type: SESSION_SUMMARY_LOADING, payload: true });
      const sessionSummaryUrl = URL.sessionSummary;
      const response = await axiosInstance.post(sessionSummaryUrl, payload, {
        signal,
      });
      dispatch({ type: SESSION_SUMMARY_ERROR, payload: null });
      dispatch({ type: SESSION_SUMMARY, payload: response?.data?.data });
    } catch (error) {
      dispatch({ type: SESSION_SUMMARY_ERROR, payload: error?.message });
    } finally {
      dispatch({ type: SESSION_SUMMARY_LOADING, payload: false });
    }
  };
};

export const getTimeUtilisationData = payload => {
  // const {time_filter}=payload;
  // time_filter : "last_30_days" || "last_90_days" || "last_6_months" || "last_year" || "all_time",

  return async dispatch => {
    try {
      dispatch({ type: TIME_UTILISATION_LOADING, payload: true });
      const timeUtilisationUrl = URL.timeUtilisation;
      const response = await axiosInstance.get(timeUtilisationUrl, {
        params: {
          time_filter: payload?.time_filter,
          client_type: payload?.client_type,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        },
      });
      dispatch({ type: TIME_UTILISATION_ERROR, payload: null });
      dispatch({ type: TIME_UTILISATION, payload: response?.data?.data });
    } catch (error) {
      dispatch({ type: TIME_UTILISATION_ERROR, payload: error?.message });
    } finally {
      dispatch({ type: TIME_UTILISATION_LOADING, payload: false });
    }
  };
};

// Commented out as the feature is parked
// export const getDiagnosisData = payload => {
//   // const {client_type, time_filter}=payload;
//   // client_type : "all" || "b2b" || "b2c" || "in-person" || "virtual",
//   // time_filter : "last_30_days" || "last_90_days" || "last_6_months" || "last_year" || "all_time",

//   return async dispatch => {
//     try {
//       dispatch({ type: DIAGNOSIS_LOADING, payload: true });
//       const response = await axiosInstance.get(URL.diagnosisAnalysis, {
//         params: {
//           client_type: payload?.client_type,
//           time_filter: payload?.time_filter,
//         },
//       });
//       dispatch({ type: DIAGNOSIS_ERROR, payload: null });
//       dispatch({ type: DIAGNOSIS, payload: response?.data?.data });
//     } catch (error) {
//       dispatch({ type: DIAGNOSIS_ERROR, payload: error?.message });
//     } finally {
//       dispatch({ type: DIAGNOSIS_LOADING, payload: false });
//     }
//   };
// };

export const getOtherInformation = payload => {
  // const {time_filter}=payload;
  // time_filter : "last_30_days" || "last_90_days" || "last_6_months" || "last_year" || "all_time",

  return async dispatch => {
    try {
      dispatch({ type: OTHER_INFORMATION_LOADING, payload: true });
      const otherInformationUrl = URL.otherInformation;
      const response = await axiosInstance.get(otherInformationUrl, {
        params: { time_filter: payload?.time_filter },
      });
      dispatch({ type: OTHER_INFORMATION_ERROR, payload: null });
      dispatch({ type: OTHER_INFORMATION, payload: response?.data?.data });
    } catch (error) {
      dispatch({ type: OTHER_INFORMATION_ERROR, payload: error?.message });
    } finally {
      dispatch({ type: OTHER_INFORMATION_LOADING, payload: false });
    }
  };
};

export const updateBatchActionStatus = payload => {
  return { type: UPDATE_BATCH_ACTION_STATUS, payload: payload };
};

export const resetBatchActionStatus = () => {
  return {
    type: RESET_BATCH_ACTION_STATUS,
    payload: { type: null, recordId: null, successCount: 0, failedCount: 0 },
  };
};
